import React, { Component } from 'react'
import Cropper from 'cropperjs'
import PropTypes from 'prop-types'

export class ImageField extends Component {
  constructor(props) {
    super(props)
    this.cropTargetRef = React.createRef()
    this.state = {
      modalIsActive: false,
      isFileValid: false,
      cropper: null,
      fileName: '',
    }
    this.handleEscape = this.handleEscape.bind(this)
    this.hasExtension = this.hasExtension.bind(this)
    this.handleFileChoosing = this.handleFileChoosing.bind(this)
    this.createCropper = this.createCropper.bind(this)
    this.handleCroppingImage = this.handleCroppingImage.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.renderCroppingModal = this.renderCroppingModal.bind(this)
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleEscape)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscape)
  }

  handleEscape(e) {
    e = e || window.event
    if (e.keyCode === 27 && this.state.modalIsActive) {
      this.closeModal()
    }
  }

  hasExtension(inputName, exts) {
    const fileName = document.querySelector(`input[name="${inputName}"]`).value
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(fileName)
  }

  handleInputFile(e) {
    e.target.value = null
  }

  handleDeleteFile() {
    this.setState({ fileName: '' })
  }

  handleFileChoosing(e) {
    const file = e.target.files[0]
    const reader = new FileReader()
    let image = ''
    reader.onload = (e) => {
      image = e.target.result
      if (
        file.size > 2000000 ||
        !this.hasExtension(this.props.name, ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'])
      ) {
        this.openModal(false)
      } else {
        this.openModal(true)
        this.createCropper(image)
      }
    }
    reader.readAsDataURL(file)
    this.setState({ fileName: file.name })
  }

  createCropper(image) {
    const cropTarget = this.cropTargetRef.current
    cropTarget.src = image
    const cropper = new Cropper(cropTarget, {
      multiple: false,
      dragCrop: false,
      dashed: false,
      movable: false,
      dragMode: 'crop',
      autoCropArea: 0.65,
      restore: false,
      guides: false,
      center: false,
      highlight: false,
      scalable: true,
      resizable: false,
      cropBoxMovable: true,
      toggleDragModeOnDblclick: false,
      viewMode: 2,
      wheelZoomRatio: 0,
      aspectRatio: this.props.imageRatio,
    })
    this.setState({ cropper: cropper })
  }

  handleCroppingImage(e) {
    e.preventDefault()
    const image = this.state.cropper.getCroppedCanvas().toDataURL()
    this.state.cropper.getCroppedCanvas().toBlob((blob) => {
      const { name, onChange } = this.props
      const { fileName } = this.state
      onChange({ target: { name, value: { image, file: blob, fileName } } })
    }, 'image/jpeg')
    this.closeModal()
  }

  openModal(isFileValid = false) {
    this.setState({ modalIsActive: true, isFileValid })
  }

  closeModal() {
    if (this.state.isFileValid && this.state.cropper) {
      this.state.cropper.destroy()
    }
    this.setState({ modalIsActive: false, isFileValid: false })
    if (this.cropTargetRef.current) {
      this.cropTargetRef.current.src = ''
    }
  }

  renderCroppingModal() {
    const classes = `modal modal--avatar-crop ${this.state.modalIsActive ? 'is-active' : ''}`
    return (
      <div className={classes}>
        <div
          className="modal-background"
          onClick={(e) => {
            e.preventDefault()
            this.closeModal()
          }}
        />
        <div className="modal-content">
          <div className="modal-cropper-wrapper">
            <img
              ref={this.cropTargetRef}
              src="#"
              style={{ display: this.state.isFileValid ? undefined : 'none' }}
            />
            {!this.state.isFileValid && (
              <div className="modal__warning">
                <strong>The uploaded file has an invalid type or exceeds the size limit.</strong>
                <small>Allowed File Types - JPG, JPEG, PNG</small>
                <small>File Size Limit - 2 MB</small>
              </div>
            )}
          </div>
          {this.state.isFileValid && (
            <button
              id="saveCropBtn"
              onClick={this.handleCroppingImage}
              className="button button-primary"
            >
              <span>Save</span>
            </button>
          )}
          {!this.state.isFileValid && (
            <button
              id="closeCropBtn"
              onClick={(e) => {
                e.preventDefault()
                this.closeModal()
              }}
              className="button button-primary"
            >
              <span>Close</span>
            </button>
          )}
        </div>
        <button
          onClick={(e) => {
            e.preventDefault()
            this.closeModal()
          }}
          className="modal-close is-large"
        />
      </div>
    )
  }

  render() {
    const { name, label, value, additionalClass, disabled, placeholderImage, renderCustomView } =
      this.props
    return (
      <div className={`field field-image ${additionalClass || ''}`}>
        {renderCustomView ? (
          renderCustomView(this.props, this.handleFileChoosing, this.handleInputFile)
        ) : (
          <div className="field-image__media-wrapper">
            <div className="field-image__media">
              <img
                src={
                  value.file === true && typeof value.image === 'object'
                    ? value.image.image
                    : value.image || placeholderImage
                }
                alt={label}
              />
            </div>
            {!disabled && (
              <div className="field-image__options">
                <label htmlFor="file-input">Upload photo</label>
                <input
                  id="file-input"
                  onChange={this.handleFileChoosing}
                  data-testid="fileChoosing"
                  onClick={this.handleInputFile}
                  type="file"
                  name={name}
                />
              </div>
            )}
          </div>
        )}
        {this.renderCroppingModal()}
      </div>
    )
  }
}

ImageField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  renderCustomView: PropTypes.func,
  label: PropTypes.string,
  placeholderImage: PropTypes.string,
  imageRatio: PropTypes.number.isRequired,
  value: PropTypes.shape({ image: PropTypes.any, file: PropTypes.any }).isRequired,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
}

export default ImageField
